/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DeleteInvoiceAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import SupportOnly from 'DesignSystem/SupportOnly/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function DeleteInvoiceAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/ActionsCell/Content/DeleteInvoiceAction"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<SupportOnly
  viewPath={`${viewPath}/SupportOnly`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 width="100%"
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Delete invoice"
/>
<TysiaTag
{...childProps}
  viewPath={`${viewPath}/TysiaTag`}
 marginLeft={dtSpaceXxs}
 style="filled"
 type="grey"
 alignSelf="center"
 size="small"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="SUPPORT ONLY"
/>
)}
</TysiaTag>
</React.Fragment>
)}
</TysiaButton>
)}
</SupportOnly>
{children}
</React.Fragment>)
}